import {
  UPDATE_QUERIES_LIST_DATA,
  UPDATE_QUERIES_LOADING,
} from "../../store/actionTypes";

const initialState = {
  total: 0,
  pageNo: 1,
  limit: 10,
  totalPage: 0,
  sortOrder: -1,
  sortBy: "createdAt",
  queriesList: [],
  isLoading: false,
  status: "",
};

/**
 *
 * @param {initial state of reducer} state
 * @param { perform actions } action
 * @returns update state of reducer
 */
const QueriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_QUERIES_LIST_DATA:
      return { ...state, ...action.payload };
    case UPDATE_QUERIES_LOADING:
      return { ...state, ...{ isLoading: !state.isLoading } };
    default:
      return { ...state };
  }
};

export default QueriesReducer;
